import React from 'react';
import { Table, Tag } from 'antd';
import dayjs from 'dayjs';

const statusColors = {
  cancelled: 'red',
  approved: 'green',
  pending: 'orange',
  rejected: 'gray',

};

const CancelledLeaveTable = ({ data, searchText, managers, departments }) => {


 const sortedData = [...data].sort(
  (a, b) => new Date(b.updated_on) - new Date(a.updated_on)
);

const filteredData = sortedData.filter(item =>
  Object.values(item).some(val =>
    val && val.toString().toLowerCase().includes(searchText.toLowerCase())
  )
);

  const columns = [
      {
      title: 'S.No',
      key: 'serial',
      render: (_, __, index) => index + 1,
      align: 'center',
    },
    {
      title: 'User ID',
      dataIndex: 'uid',
      key: 'uid',
      align: 'center',
      onCell: () => ({ style: { padding: '25px' } }),
    },
    {
      title: 'Department',
      dataIndex: 'department_name',
      key: 'department_name',
      align: 'center',
      render: (text) => text || '-',
      onCell: () => ({ style: { padding: '8px 12px' } }),
    },
    {
      title: 'Manager',
      dataIndex: 'reporting_manager',
      key: 'manager',
      align: 'center',
      render: (managerId) => {
        const manager = managers.find(m => m.uid === managerId);
        return manager ? manager.name : managerId || '-';
      },
      onCell: () => ({ style: { padding: '8px 12px' } }),
    },
    {
      title: 'From Date',
      dataIndex: 'from_date',
      key: 'fromDate',
      align: 'center',
      render: (date) => dayjs(date).format('YYYY-MM-DD'),
      onCell: () => ({ style: { padding: '8px 12px' } }),
    },
    {
      title: 'To Date',
      dataIndex: 'to_date',
      key: 'toDate',
      align: 'center',
      render: (date) => dayjs(date).format('YYYY-MM-DD'),
      onCell: () => ({ style: { padding: '8px 12px' } }),
    },
    {
      title: 'Cancelled On',
      dataIndex: 'updated_on',
      key: 'cancelledOn',
      align: 'center',
      render: (date) => dayjs(date).format('YYYY-MM-DD hh:mm A'),
      onCell: () => ({ style: { padding: '8px 12px' } }),
    },
    {
      title: 'Status',
      dataIndex: 'status',
      key: 'status',
      align: 'center',
      render: (status) => {
        const color = statusColors[status?.toLowerCase()] || 'blue';
        return status ? (
          <Tag color={color} style={{ fontWeight: 'bold', padding: '2px 8px' }}>
            {status.charAt(0).toUpperCase() + status.slice(1)}
          </Tag>
        ) : (
          '-'
        );
      },
      onCell: () => ({ style: { padding: '8px 12px' } }),
    },
    {
      title: 'Comment',
      dataIndex: 'comment',
      key: 'comment',
      align: 'center',
      render: (comment) => comment || '-',
      onCell: () => ({ style: { padding: '8px 12px' } }),
    },
  ];


  return (
    <Table
      columns={columns}
      dataSource={filteredData}
      pagination={false}
      rowKey="id"
      scroll={{ x: 'max-content' }}

    />
  );
};

export default CancelledLeaveTable;
